import React from 'react';
import { MessageSquare, Calendar, User } from 'lucide-react';
import { Testimonial } from '../lib/testimonials';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface TestimonialCardProps {
  testimonial: Testimonial;
  showAuthor?: boolean;
}

export default function TestimonialCard({ testimonial, showAuthor = false }: TestimonialCardProps) {
  const formatDate = (dateString: string) => {
    return format(new Date(dateString), 'dd/MM/yyyy', { locale: ptBR });
  };

  return (
    <div className="bg-white rounded-xl shadow-elevation-1 hover:shadow-elevation-2 transition-shadow overflow-hidden">
      <div className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <MessageSquare className="h-5 w-5 text-brand-teal" />
          <h3 className="text-xl font-semibold text-brand-teal">{testimonial.title}</h3>
        </div>
        
        <div className="mb-4">
          <p className="text-gray-700 whitespace-pre-line">
            {testimonial.content}
          </p>
        </div>
        
        <div className="flex items-center justify-between text-sm text-gray-500">
          {showAuthor && (
            <div className="flex items-center gap-1">
              <User className="h-4 w-4" />
              <span>Anônimo</span>
            </div>
          )}
          <div className="flex items-center gap-1">
            <Calendar className="h-4 w-4" />
            <span>{formatDate(testimonial.approved_at || testimonial.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}